<template>
  <div>
    <div class="d-flex justify-center align-center py-2 px-4" style="height: 80px">
      <ColumnsVisibilityControl
        :defaults="headers"
        :withColumnsOrder="true"
        v-model="docsHeaders"
        storageKey="task-documents"
        class="mr-2" />
      <v-text-field
        class="customSearchBox me-2"
        outlined
        rounded
        dense
        hide-details
        v-model="options.search"
        :loading="loading"
        placeholder="Search..."
        append-icon="mdi-magnify"></v-text-field>
      <!-- <v-text-field outlined id="search" name="task-serach" dense hide-details clearable v-virtual-keyboard
        append-icon="mdi-magnify" label="Search" style="width: 300px" class="v-min-input mr-2" placeholder="Search..."
        :loading="loading" v-model="options.search"> </v-text-field> -->
      <v-btn class="primary" rounded @click="openUploadModal()" v-if="$has(permissions.Documents.Upload)">
        Upload <v-icon class="ml-2" small>mdi-tray-arrow-up </v-icon>
      </v-btn>
    </div>
    <div>
      <div>
        <v-data-table
          id="tasks-documents"
          attach
          style="height: calc(100vh - 300px)"
          class="elevation-1 pa-2 rounded-0 scrollable-content"
          :headers="tableHeaders"
          :loading="loading"
          :items="entries"
          :options.sync="options"
          item-key="id"
          :server-items-length="total"
          :items-per-page="options.itemsPerPage"
          :footer-props="{
            showFirstLastPage: true,

            itemsPerPageText: 'Row/Page',
            itemsPerPageOptions: [50, 100, 200, -1],
          }"
          :disable-sort="entries && entries.length == 0"
          @dblclick:row="rowClicked">
          <template v-slot:[`item.fileName`]="{ item }">
            <AppFile :file="item" />
          </template>
          <template v-slot:[`item.createDate`]="{ item }">
            <div v-if="item.createDate" style="min-width: 100px;">
              {{ $formatDate(item.createDate) }}
            </div>
          </template>
          <template v-slot:[`item.createdBy`]="{ item }">
            <div v-if="item.createdBy" style="min-width: 100px;">
              {{ item.createdBy}}
            </div>
          </template>
          <template v-slot:[`item.revisionNumber`]="{ item }" >
            <div style="min-width: 100px;">
              <v-chip small color="primary">{{ item.revisionNumber }}</v-chip>
              <v-chip v-if="item.currentVersionNumber" small outlined class="ml-1"
                :title="item.isCurrentOverridden ? 'Pinned as current' : 'Current version'">
                v{{ item.currentVersionNumber }}
                <v-icon v-if="item.isCurrentOverridden" x-small right color="warning">mdi-pin</v-icon>
              </v-chip>
            </div>
          </template>
          <template v-slot:[`item.documentType`]="{ item }">
            <div style="min-width: 100px;">
              <v-chip x-small>
              {{ item.documentType }}
            </v-chip>
              </div>  
           
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <v-menu dense offset-y  right bottom attach>
              <template v-slot:activator="{ attrs, on }">
                <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                  <v-icon size="16px">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list class="more-options-menu" dense>
                <v-list-item v-has="permissions.Tasks.Update" @click="openDocument(item)" dense>
                  <v-list-item-icon class="mr-2 justify-center">
                    <v-icon small>fa-reqular fa-eye</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>View</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
             
                <v-list-item v-if="$has(permissions.Documents.Upload)" @click="addRevision(item)" dense>
                  <v-list-item-icon class="mr-2 justify-center">
                    <v-icon small> fa-solid fa-plus </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>Upload New Version</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  v-if="$has(permissions.Documents.View)"
                  @click="showVersions(item)"
                  dense>
                  <v-list-item-icon class="mr-2 justify-center">
                    <v-icon small> fa-solid fa-clock-rotate-left </v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> Versions</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item v-if="$has(permissions.Documents.Delete)" @click="delDocument(item.id)" dense>
                  <v-list-item-icon class="mr-2 justify-center">
                    <v-icon small color="error">mdi-delete-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title> Delete</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>

          <template v-slot:no-data>
            <div class="text-center d-flex flex-column">
              <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
              <p class="font-weight-medium">No Data Available!</p>
            </div>
          </template>

          <template v-slot:loading>
            <div class="text-center d-flex flex-column">
              <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
              <p class="font-weight-medium">Loading...</p>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- Uploads run in the background (DocumentUploadTray); the list reloads on DOCUMENTS_UPLOADED -->
    <AddDocumentPopup ref="addDocumentPopup" :task_id="taskId" :document_type_id="defaultTypeId" />
    <AddDocumentVersionDialog
      v-if="addVersion.open"
      v-model="addVersion.open"
      :document-id="addVersion.document.id"
      :document="addVersion.document" />
    <!-- z-index: above the Edit Task slide-out (1997), below the confirm dialogs (2000) -->
    <DocumentWorkspaceDialog ref="documentWorkspace" :z-index="1999" @changed="onDocumentChanged" />
  </div>
</template>

<script>
  import headers from '../config/task-documents-header';
  import AddDocumentPopup from '@/components/attachments/add-document-popup.vue';
  import AddDocumentVersionDialog from '@/features/Documents/components/AddDocumentVersionDialog.vue';
  import { EventBus, DOCUMENT_EVENTS } from '@/event-bus';
  import { mapGetters } from 'vuex';
  import permissions from '@Share/config/permissions';
  import { $formatDate, $getFromLocal, $setToLocal, $has, $updateOrAdd } from '@Utils';
  import AppFile from '@Share/components/AppFile.vue';
  import DocumentWorkspaceDialog from '@/features/Documents/components/DocumentWorkspaceDialog.vue';
  import ColumnsVisibilityControl from '@Share/components/ColumnsVisibilityControl.vue';
  export default {
    data() {
      return {
        taskId: '',
        headers,
        docsHeaders: headers,
        permissions,
        timerId: null,
        addVersion: { open: false, document: null },
      };
    },
    computed: {
      /** The type new documents get; the task page loads the list itself (DOCUMENT_TYPE/GET). */
      defaultTypeId() {
        const name = this.$store.getters['GET_DEFAULT_DOCUMENT_TYPE'] ?? 'Specifications';
        const types = this.$store.getters['DOCUMENT_TYPE/GET_ENTRIES'] || [];
        return types.find((t) => t.name == name)?.id ?? null;
      },
      tableHeaders() {
        return this.docsHeaders.filter((elm) => !elm.hidden);
      },
      ...mapGetters('TASK_DOCUMENT', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
      }),
      options: {
        get() {
          return this.$store.getters['TASK_DOCUMENT/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('TASK_DOCUMENT/SET_OPTIONS', val);
        },
      },
    },
    methods: {
      $formatDate,
      $has,
      open(id) {
        this.taskId = id;
        this.getData();
      },
      getData() {
        this.$store.dispatch('TASK_DOCUMENT/GET_BY_TASK_ID', this.taskId);
      },
      openUploadModal() {
        this.$refs.addDocumentPopup.open();
      },
      /** A finished background upload for this task: reload, so the new rows show with their ids. */
      onDocumentsUploaded(payload) {
        if (payload?.context?.taskId != this.taskId) return;
        this.getData();
      },
      openDocument(item) {
        this.$refs.documentWorkspace.open({ documentId: item.id, document: item });
      },
      delDocument(id) {
        this.$dialog.error({
          text: 'Are You Sure You Want to Delete This Document?',

          title: 'Delete Document',
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.$store.dispatch('TASK_DOCUMENT/DELETE', id);
              },
            },
          },
        });
      },
      rowClicked(mouseEvent, ev) {
        this.$refs.documentWorkspace.open({ documentId: ev.item.id, document: ev.item });
      },
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.getData();
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.getData();
        }, 400);
      },
      /** New version through the background queue; DOCUMENT_CHANGED updates the row when it lands. */
      addRevision(item) {
        this.addVersion = { open: true, document: item };
      },
      showVersions(item) {
        this.$refs.documentWorkspace.open({ documentId: item.id, document: item, tab: 'versions' });
      },
      onDocumentChanged(document) {
        if (this.entries.some((e) => e.id === document?.id)) $updateOrAdd(this.entries, document);
      },
    },
    created() {
      this.options.itemsPerPage = parseInt(
        $getFromLocal('task-documents-table-itemsPerPage', false, 15),
      );
      this.$store.dispatch('DOCUMENT_TYPE/GET');
      EventBus.$on(DOCUMENT_EVENTS.DOCUMENTS_UPLOADED, this.onDocumentsUploaded);
      EventBus.$on(DOCUMENT_EVENTS.DOCUMENT_CHANGED, this.onDocumentChanged);
    },
    beforeDestroy() {
      EventBus.$off(DOCUMENT_EVENTS.DOCUMENTS_UPLOADED, this.onDocumentsUploaded);
      EventBus.$off(DOCUMENT_EVENTS.DOCUMENT_CHANGED, this.onDocumentChanged);
      clearTimeout(this.timerId);
    },
    watch: {
      options: {
        handler(newOptions) {
          $setToLocal('task-documents-table-itemsPerPage', newOptions.itemsPerPage);
          this.getDataDebounced();
        },
        deep: true,
      },
    },
    components: {
      AddDocumentPopup,
      AddDocumentVersionDialog,
      AppFile,
      DocumentWorkspaceDialog,
      ColumnsVisibilityControl,
    },
  };
</script>

<style lang="scss">
  #tasks-documents {
    .v-data-table__wrapper {
      padding: 0px 10px;
      table {
        border-spacing: 0 10px !important;
      }
      thead.v-data-table-header {
        background-color: var(--v-colored_bg-base);
        border-radius: 4px;
      }
      tbody {
        tr {
          box-shadow: 0px 0px 20px 0px #0000000d;
          margin-bottom: 10px;
        }
        tr:not(:last-child) {
          td {
            background-color: var(--v-white-base);
            // border-bottom: 10px solid #f4f5f4;
          }
        }
        td {
          background-color: var(--v-white-base);
        }

        td {
          padding: 12px;
          text-align: center;
        }
      }
      th {
        padding: 12px;
        text-align: center;
        border-bottom: 0px;
      }

      th:first-child,
      td:first-child {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
      }
      th:last-child,
      td:last-child {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;
      }
    }
  }
  #tasks-documents .v-data-footer {
    bottom: 50px;
  }
</style>
